"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginApi_1 = require("../api/LoginApi");
var CommonFunctions_1 = require("../components/common/CommonFunctions/CommonFunctions");
var FeatureToggleService_1 = require("./FeatureToggleService");
var UrlParameterHelper_1 = require("./UrlParameterHelper");
var FEATURE_TOGGLE_REFRESH_USES_HALO = 'svc-idm-refresh-uses-halo';
var SessionRefreshService = /** @class */ (function () {
    function SessionRefreshService(props) {
        this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        this.myattUserInfoUtil = props.data.myattUserInfoUtil;
        this.props = props;
    }
    /**
     * refresh - triggers steps needed for session refresh
     * When complete the returned promise will resolve
     */
    SessionRefreshService.prototype.refresh = function () {
        var _this = this;
        // If we don't have this, we need to just skip out
        if (this.myattUserInfoUtil) {
            return new Promise(function (resolve) {
                var refreshProm = _this.myattUserInfoUtil.refreshServicesCommonCache(null, null, true, 'idp');
                refreshProm.then(function (status) {
                    console.log("login-ui::SessionRefreshService - runRefresh fininished: " + status);
                    // Giving this the resolve method so it can trigger the completion when done.
                    _this.continueAfterCommonRefresh(resolve);
                }).catch(function (error) {
                    console.error('login-ui::SessionRefreshService - runRefresh threw an error', error);
                    // Giving this the resolve method so it can trigger the completion when done.
                    _this.continueAfterCommonRefresh(resolve);
                });
            });
        }
        else {
            console.error('login-ui::SessionRefreshService - runRefresh called but no UserInfoUtil available');
            return Promise.resolve(true);
        }
    };
    SessionRefreshService.prototype.continueAfterCommonRefresh = function (resolve) {
        var _this = this;
        var forceHalo = this.commonFunctions.notBlankCheck(this.commonFunctions.getQueryParam('halo'));
        var checkDoHaloPromise;
        if (forceHalo) {
            console.log('login-ui::SessionRefreshService - halo=true param, forcing HALO');
            checkDoHaloPromise = Promise.resolve(true);
        }
        else {
            checkDoHaloPromise = FeatureToggleService_1.default.checkFeatureToggleEnabled(FEATURE_TOGGLE_REFRESH_USES_HALO);
        }
        checkDoHaloPromise.then(function (doHalo) {
            console.log("login-ui::SessionRefreshService - result of checking whether to go to halo:: " + doHalo);
            if (doHalo) {
                _this.rebuildGatewaySession(resolve);
            }
            else {
                // We are all set, let the loginConsole run.
                resolve(true);
            }
        }).catch(function (excep) {
            console.error('login-ui::SessionRefreshService - checking feature toggle failed!', excep);
            resolve(true);
        });
    };
    SessionRefreshService.prototype.rebuildGatewaySession = function (resolve) {
        // Update the login page url removing the refresh and halo flags
        this.cleanUrlParams();
        // Call invalidate session
        var api = new LoginApi_1.default();
        api.invalidateSession(true).then(function () {
            // Resolve true to trigger login console
            resolve(true);
        }).catch(function () {
            // Resolve true to trigger login console
            resolve(true);
        });
    };
    SessionRefreshService.prototype.cleanUrlParams = function () {
        try {
            var helper = UrlParameterHelper_1.default.getInstance();
            helper.delete('halo');
            helper.delete('refresh');
            var search = helper.toString();
            if (search) {
                search = '?' + search;
            }
            // This is the path with in the /acctmgmt context
            this.props.history.replace("/login" + search);
        }
        catch (e) {
            console.error('login-ui:SessionRefreshService - exception updating URL', e);
            this.props.history.replace("/login");
        }
    };
    return SessionRefreshService;
}());
exports.default = SessionRefreshService;
//# sourceMappingURL=SessionRefreshService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/SessionRefreshService.js
// module id = 1693
// module chunks = 8